var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification instruction",class:{
  [`${_vm.type}`]: true,
  'is-dark': _vm.$themeDark,
  'is-light': _vm.$themeLight,
}},[_c('div',{staticClass:"is-flex is-align-items-center"},[_c('div',{staticClass:"instruction-message is-flex-grow-1"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }